<div class="notification-icon-wrapper">
    <nuc-icon [ngClass]="showNotificationIcon? 'ringtone-icon' :'hideNotificationIcon' " class="{{displayClass}}" iconClass="stla-ringtone-new" size="{{size}} material-icons-outlined"
     [matMenuTriggerFor]="notification" (click)="fetchNotifications(false, $event)"
        #ringtone></nuc-icon>
    @if(hasUnreadNotifications && showNotificationIcon){
    <span class="dot"></span>
    }
</div>

<mat-menu class="notifClass" #notification="matMenu">
    <div class="notificationSection">
        <div class="notificationSection-title">{{(pageContent | contentFilter:
            LABELS.NOTIFICATIONS_OVERLAY_LABELS.NOTIFICATIONS_LABEL) || 'Notifications'}}</div>
        @if (unreadNotifications?.length) {
        @for (item of topNotifications; track $index) {
        <nuc-notification-link [item]="item" displayClass="notification-overlay-links"></nuc-notification-link>
        } }
        @else {
        <hr class="divider">
        <nuc-icon class="info-icon" iconClass="info_outlined" color="#5F5E62"
            size="64 material-icons-outlined"></nuc-icon>
        <p class="info-message-text">{{(pageContent | contentFilter:
            LABELS.NOTIFICATIONS_OVERLAY_LABELS.NO_NEW_NOTIFICATIONS_TEXT) || 'No new Notifications'}}</p>
        }
    </div>
    <nuc-link-button class="view-more-link" styleClass="link-button button-light"
        text="{{(pageContent | contentFilter: LABELS.NOTIFICATIONS_OVERLAY_LABELS.VIEWMORE_BUTTON_TEXT) || 'View More'}}"
       (click)="fetchNotifications(true)"></nuc-link-button>
</mat-menu>